import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import Sidebar from '../../components/shared/Sidebar';
import { FiPlus, FiCheck, FiX } from 'react-icons/fi';

const STATUS_COLORS = { pending: 'badge-warning', confirmed: 'badge-success', completed: 'badge-primary', cancelled: 'badge-danger', no_show: 'badge-danger' };

export default function ShopBookings() {
  const [bookings, setBookings] = useState([]);
  const [services, setServices] = useState([]);
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dateFilter, setDateFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [modal, setModal] = useState(false);
  const [waModal, setWaModal] = useState(false);
  const [waLink, setWaLink] = useState('');
  const [walkinModal, setWalkinModal] = useState(false);
  const [walkinForm, setWalkinForm] = useState({ customer_name: "", customer_phone: "", service_id: "", staff_id: "", custom_price: "" });

  const loadDropdowns = async () => {
    try {
      const [s, st] = await Promise.all([
        axios.get('/api/shop/services'),
        axios.get('/api/shop/staff')
      ]);
      setServices(s.data || []);
      setStaff(st.data || []);
    } catch {}
  };

  const openWalkin = () => {
    loadDropdowns();
    setWalkinForm({ customer_name: '', customer_phone: '', service_id: '', staff_id: '', custom_price: '' });
    setWalkinModal(true);
  };

  const saveWalkin = async () => {
    try {
      await axios.post('/api/shop/walkin', walkinForm);
      toast.success('Walk-in entry ho gayi!');
      setWalkinModal(false);
      load();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Error');
    }
  };
  const [form, setForm] = useState({ customer_name: '', customer_phone: '', customer_whatsapp: '', booking_date: '', booking_time: '', service_id: '', staff_id: '', notes: '', booked_via: 'walk_in' });

  const load = useCallback(() => {
    setLoading(true);
    axios.get('/api/shop/bookings', { params: { date: dateFilter, status: statusFilter } })
      .then(r => setBookings(r.data)).finally(() => setLoading(false));
  }, [dateFilter, statusFilter]);

  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    axios.get('/api/shop/services').then(r => setServices(r.data));
    axios.get('/api/shop/staff').then(r => setStaff(r.data));
  }, []);

  const updateStatus = async (id, status) => {
    try {
      const r = await axios.patch(`/api/shop/bookings/${id}/status`, { status });
      toast.success('Status update ho gaya');
      load();
      // Open WhatsApp in same window flow (avoids popup blocker)
      if (status === 'confirmed' && r.data.waLink) {
        const link = document.createElement('a');
        link.href = r.data.waLink;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
    catch { toast.error('Error'); }
  };

  const deleteBooking = async (id) => {
    if (!window.confirm('Yeh booking delete karna chahte hain?')) return;
    try { await axios.delete(`/api/shop/bookings/${id}`); toast.success('Deleted!'); load(); }
    catch { toast.error('Error'); }
  };

  const handleAddBooking = async (e) => {
    e.preventDefault();
    try { await axios.post('/api/shop/bookings', form); toast.success('Booking add ho gayi!'); setModal(false); load(); }
    catch (err) { toast.error(err.response?.data?.message || 'Error'); }
  };

  const set = (k, v) => setForm(f => ({...f, [k]: v}));
  const [today, setToday] = useState('');
  useEffect(() => {
    axios.get('/api/shop/reports/today').then(r => setToday(r.data.today)).catch(() => {
      const now = new Date();
      const pk = new Date(now.getTime() + 5*60*60*1000 + now.getTimezoneOffset()*60*1000);
      setToday(pk.toISOString().split('T')[0]);
    });
  }, []);

  return (
    <div className="app-layout">
      <Sidebar />
      <div className="main-content">
        <div className="flex-between page-header">
          <div><h1>Bookings</h1><p>Sab appointments manage karein</p></div>
          <div className="flex gap-2"><button className="btn btn-primary" onClick={() => setModal(true)}><FiPlus /> Nai Booking</button><button className="btn" style={{ background: '#25D366', color: 'white' }} onClick={openWalkin}>🚶 Walk-in</button></div>
        </div>

        <div className="card mb-4">
          <div className="flex gap-3" style={{ flexWrap: 'wrap' }}>
            <div className="form-group" style={{ margin: 0 }}>
              <label className="form-label">Date Filter</label>
              <input type="date" className="form-control" value={dateFilter} onChange={e => setDateFilter(e.target.value)} />
            </div>
            <div className="form-group" style={{ margin: 0 }}>
              <label className="form-label">Status</label>
              <select className="form-control" value={statusFilter} onChange={e => setStatusFilter(e.target.value)}>
                <option value="">Sab</option>
                {['pending','confirmed','completed','cancelled','no_show'].map(s => <option key={s} value={s}>{s}</option>)}
              </select>
            </div>
            <div style={{ alignSelf: 'flex-end' }}>
              <button className="btn btn-outline btn-sm" onClick={() => { setDateFilter(today); setStatusFilter(''); }}>Aaj</button>
            </div>
            <div style={{ alignSelf: 'flex-end' }}>
              <button className="btn btn-outline btn-sm" onClick={() => { setDateFilter(''); setStatusFilter(''); }}>Clear</button>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="table-wrapper">
            {loading ? <div style={{ textAlign: 'center', padding: '40px' }}><div className="spinner" style={{ margin: '0 auto' }} /></div> : (
              <table>
                <thead><tr><th>Ref</th><th>Customer</th><th>Date & Time</th><th>Service</th><th>Staff</th><th>Via</th><th>Status</th><th>Actions</th></tr></thead>
                <tbody>
                  {bookings.map(b => (
                    <tr key={b.id}>
                      <td style={{ fontSize: '12px', fontFamily: 'monospace', color: 'var(--text-light)' }}>{b.booking_ref}</td>
                      <td>
                        <div style={{ fontWeight: 600 }}>{b.customer_name}</div>
                        <div style={{ fontSize: '12px' }}>{b.customer_phone}</div>
                      </td>
                      <td>
                        <div>{new Date(b.booking_date).toLocaleDateString('en-PK')}</div>
                        <div style={{ fontSize: '12px', color: 'var(--text-light)' }}>{b.booking_time?.slice(0,5)}</div>
                      </td>
                      <td>
                        <div>{b.service_name || '—'}</div>
                        {b.service_price > 0 && <div style={{ fontSize: '12px', color: 'var(--success)' }}>PKR {Number(b.service_price).toLocaleString()}</div>}
                      </td>
                      <td>{b.staff_name || '—'}</td>
                      <td><span className="badge badge-info" style={{ fontSize: '10px' }}>{b.booked_via}</span></td>
                      <td><span className={`badge ${STATUS_COLORS[b.status]}`}>{b.status}</span></td>
                      <td>
                        <div className="flex gap-2" style={{ flexWrap: 'wrap' }}>
                          {b.status === 'pending' && <>
                            <button className="btn btn-success btn-sm" onClick={() => updateStatus(b.id, 'confirmed')} title="Confirm"><FiCheck /></button>
                            <button className="btn btn-danger btn-sm" onClick={() => updateStatus(b.id, 'cancelled')} title="Cancel"><FiX /></button>
                          </>}
                          {b.status === 'confirmed' && <button className="btn btn-sm" style={{ background: '#d1ecf1', fontSize: '11px' }} onClick={() => updateStatus(b.id, 'completed')}>✅ Done</button>}
                          {b.customer_whatsapp && <a href={`https://wa.me/${b.customer_whatsapp}`} target="_blank" rel="noreferrer" className="btn btn-whatsapp btn-sm" style={{ fontSize: '11px' }}>📲</a>}
                          <button className="btn btn-danger btn-sm" title="Delete" onClick={() => deleteBooking(b.id)} style={{ fontSize: '11px' }}>🗑</button>
                        </div>
                      </td>
                    </tr>
                  ))}
                  {bookings.length === 0 && <tr><td colSpan={8} style={{ textAlign: 'center', padding: '40px', color: '#999' }}>Koi booking nahi mili</td></tr>}
                </tbody>
              </table>
            )}
          </div>
        </div>

        {/* WhatsApp Confirmation Modal */}
        {waModal && (
          <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setWaModal(false)}>
            <div className="modal" style={{ maxWidth: '400px', textAlign: 'center' }}>
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>📲</div>
              <h3 style={{ marginBottom: '12px' }}>Customer ko Confirm Bhejna Hai?</h3>
              <p style={{ color: 'var(--text-light)', marginBottom: '24px', fontSize: '14px' }}>
                Customer ke WhatsApp pe booking confirmation message jayega
              </p>
              <div className="flex gap-3" style={{ justifyContent: 'center' }}>
                <a href={waLink} target="_blank" rel="noreferrer" className="btn btn-whatsapp btn-lg" onClick={() => setWaModal(false)}>
                  📲 WhatsApp Kholein
                </a>
                <button className="btn btn-outline" onClick={() => setWaModal(false)}>Baad Mein</button>
              </div>
            </div>
          </div>
        )}

        {modal && (
          <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setModal(false)}>
            <div className="modal">
              <div className="modal-header"><h3>➕ Nai Booking</h3><button className="modal-close" onClick={() => setModal(false)}>×</button></div>
              <form onSubmit={handleAddBooking}>
                <div className="grid-2">
                  <div className="form-group"><label className="form-label">Customer Naam *</label><input className="form-control" value={form.customer_name} onChange={e => set('customer_name', e.target.value)} required /></div>
                  <div className="form-group"><label className="form-label">Phone *</label><input className="form-control" value={form.customer_phone} onChange={e => set('customer_phone', e.target.value)} required /></div>
                  <div className="form-group"><label className="form-label">WhatsApp (optional)</label><input className="form-control" value={form.customer_whatsapp} onChange={e => set('customer_whatsapp', e.target.value)} placeholder="923XXXXXXXXX" /></div>
                  <div className="form-group"><label className="form-label">Booking Via</label>
                    <select className="form-control" value={form.booked_via} onChange={e => set('booked_via', e.target.value)}>
                      <option value="whatsapp">WhatsApp</option><option value="website">Website</option><option value="walk_in">Walk-in</option>
                    </select>
                  </div>
                  <div className="form-group"><label className="form-label">Date *</label><input type="date" className="form-control" value={form.booking_date} onChange={e => set('booking_date', e.target.value)} required /></div>
                  <div className="form-group"><label className="form-label">Time *</label><input type="time" className="form-control" value={form.booking_time} onChange={e => set('booking_time', e.target.value)} required /></div>
                  <div className="form-group"><label className="form-label">Service</label>
                    <select className="form-control" value={form.service_id} onChange={e => set('service_id', e.target.value)}>
                      <option value="">— Select Service —</option>
                      {services.map(s => <option key={s.id} value={s.id}>{s.name} — PKR {s.price}</option>)}
                    </select>
                  </div>
                  <div className="form-group"><label className="form-label">Staff</label>
                    <select className="form-control" value={form.staff_id} onChange={e => set('staff_id', e.target.value)}>
                      <option value="">— Any Staff —</option>
                      {staff.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
                    </select>
                  </div>
                </div>
                <div className="form-group"><label className="form-label">Notes</label><textarea className="form-control" rows={2} value={form.notes} onChange={e => set('notes', e.target.value)} /></div>
                <button className="btn btn-primary btn-full" type="submit">✅ Booking Add Karein</button>
              </form>
            </div>
          </div>
        )}
      </div>

      {walkinModal && (
        <div className="modal-overlay" onClick={() => setWalkinModal(false)}>
          <div className="modal-content" onClick={e => e.stopPropagation()} style={{ maxWidth: '500px' }}>
            <h2 style={{ marginBottom: '16px' }}>➕ Walk-in Customer</h2>
            <p style={{ color: 'var(--text-light)', fontSize: '13px', marginBottom: '16px' }}>Bina booking aaye customer ki entry — direct "completed" status mein save hogi</p>
            <div className="form-group">
              <label className="form-label">👤 Customer Name (optional)</label>
              <input className="form-control" placeholder="Walk-in Customer" value={walkinForm.customer_name} onChange={e => setWalkinForm({...walkinForm, customer_name: e.target.value})} />
            </div>
            <div className="form-group">
              <label className="form-label">📱 Phone (optional)</label>
              <input className="form-control" placeholder="03XXXXXXXXX" value={walkinForm.customer_phone} onChange={e => setWalkinForm({...walkinForm, customer_phone: e.target.value})} />
            </div>
            <div className="form-group">
              <label className="form-label">✂️ Service *</label>
              <select className="form-control" value={walkinForm.service_id} onChange={e => {
                const svc = services.find(s => String(s.id) === e.target.value);
                setWalkinForm({...walkinForm, service_id: e.target.value, custom_price: svc ? svc.price : ''});
              }}>
                <option value="">-- Service Select Karein --</option>
                {services.map(s => <option key={s.id} value={s.id}>{s.name} — PKR {s.price}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">💈 Barber *</label>
              <select className="form-control" value={walkinForm.staff_id} onChange={e => setWalkinForm({...walkinForm, staff_id: e.target.value})}>
                <option value="">-- Barber Select Karein --</option>
                {staff.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">💰 Price (PKR)</label>
              <input className="form-control" type="number" placeholder="0" value={walkinForm.custom_price} onChange={e => setWalkinForm({...walkinForm, custom_price: e.target.value})} />
              <small style={{ fontSize: '11px', color: 'var(--text-light)' }}>Service select karne se auto fill — agar customer ne kam/zyada diye toh change karein</small>
            </div>
            <div className="flex gap-2" style={{ marginTop: '20px' }}>
              <button className="btn btn-outline" onClick={() => setWalkinModal(false)} style={{ flex: 1 }}>Cancel</button>
              <button className="btn btn-success" onClick={saveWalkin} style={{ flex: 1 }}>✅ Save Entry</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
